// Import AppSignal libraries
import Appsignal from '@appsignal/javascript';
import { plugin } from '@appsignal/plugin-window-events';

console.info('[APPSIGNAL]: Initializing AppSignal for frontend error monitoring');

if (!window.APPSIGNAL_FRONTEND_KEY) {
  console.info('[APPSIGNAL]: No frontend API key found for this environment, skipping initialization');
} else {
  const appsignal = new Appsignal({
    key: window.APPSIGNAL_FRONTEND_KEY,
    name: "SixtyFiveWinks",
    environment: window.APPSIGNAL_ENVIRONMENT || "development",
    revision: window.APPSIGNAL_REVISION,
    defaultTags: {
      url: window.location.href,
      path: window.location.pathname,
      userAgent: navigator.userAgent
    },
    sendSessionStarted: true,
    enableSourceMaps: true,
    enableSourceMaps: true,
    captureUnhandledRejections: true,
    sendSessionStarted: true,
    ignoreErrors: [
      // Ignore common third-party errors
      // "Script error",
      // "ResizeObserver loop limit exceeded",
      // /^Network error/,
      // /^Loading chunk .* failed/,
      // /^Cannot read property .* of undefined$/,
      // /^Cannot read property .* of null$/
    ]
  });

  appsignal.use(plugin());
  window.AppSignal = appsignal;
}
